import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosLogsMixin = {
  computed: {
    permisosLogs() {
      return {
        moduloLogs: tienePermiso('logs'),
      };
    },
  },
};
